module.exports = __webpack_public_path__ + "static/media/back-white-arrow.9f4ce9d9.svg";